import React, { useEffect, useRef, useState } from 'react';
import { FormControl } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { encodeBuild, hide, copyUrl } from './skillShareSlice';
import { show as showToast } from '../toast/toastSlice';

function InnerSkillShareModal() {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  const [url, setUrl] = useState('');

  useEffect(() => {
    const baseUrl = window.location.href.split('?', 2)[0];
    const code = dispatch(encodeBuild());
    setUrl(baseUrl + '?code=' + code);
    setTimeout(() => inputRef.current?.select());
  }, [dispatch]);

  const handleCopyClick = () => {
    dispatch(copyUrl(url));
    dispatch(showToast('Copied to clipboard.'));
  };

  const handleCloseClick = () => {
    dispatch(hide());
  }
  
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code === 'Enter') {
      e.preventDefault();
      handleCopyClick();
    }
  };

  return (
    <Modal show={true} onHide={() => handleCloseClick()}>
      <Modal.Header closeButton>
        <Modal.Title>Share</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label>Copy and paste the link below:</label>
        <FormControl as="input" value={url} onKeyDown={handleKeyDown} ref={inputRef} readOnly />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => handleCloseClick()}>
          Cancel
        </Button>
        <Button variant="primary" onClick={() => handleCopyClick()}>
          Copy
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function SkillShareModal() {
  const visible = useAppSelector(state => state.skillShare.visible);  
  return visible ? <InnerSkillShareModal/> : null;
}

export default SkillShareModal;